module.exports = __webpack_public_path__ + "static/media/CloudDesktop_002.aebf99e0.png";